import { render, staticRenderFns } from "./BuyLicence.vue?vue&type=template&id=4414f5f0&scoped=true"
import script from "./BuyLicence.vue?vue&type=script&lang=js"
export * from "./BuyLicence.vue?vue&type=script&lang=js"
import style0 from "./BuyLicence.vue?vue&type=style&index=0&id=4414f5f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4414f5f0",
  null
  
)

/* custom blocks */
import block0 from "./BuyLicence.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports